export type IcDividerStyles = "solid" | "dashed";
export type IcDividerWeights = "thin" | "medium" | "thick" | "very-thick";
export type IcDividerLabelPlacement =
  | "left"
  | "center"
  | "right"
  | "top"
  | "bottom";
